import React from 'react';
import { getDeviceInfo, isAndroidDevice, isMobileDevice, isTabletDevice, isWebView, isPWA, isIOSDevice, isInMobileApp, getAppBundleId, getAppFramework, shouldShowIOSWebViewAlert, showIOSWebViewAlert } from '../utils/deviceDetection';

const DeviceDetectionTest: React.FC = () => {
  const deviceInfo = getDeviceInfo();
  const appFramework = getAppFramework();

  return (
    <div className="p-4 bg-gray-100 rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Device Detection Test</h3>
      <div className="space-y-2 text-sm">
        <div><strong>User Agent:</strong> {deviceInfo.userAgent}</div>
        <div><strong>Platform:</strong> {deviceInfo.platform}</div>
        <div><strong>Is iOS:</strong> {isIOSDevice() ? 'Yes' : 'No'}</div>
        <div><strong>Is Android:</strong> {deviceInfo.isAndroid ? 'Yes' : 'No'}</div>
        <div><strong>Is Mobile:</strong> {deviceInfo.isMobile ? 'Yes' : 'No'}</div>
        <div><strong>Is Tablet:</strong> {deviceInfo.isTablet ? 'Yes' : 'No'}</div>
        <div><strong>Is Desktop:</strong> {deviceInfo.isDesktop ? 'Yes' : 'No'}</div>
        <div><strong>Is WebView:</strong> {isWebView() ? 'Yes' : 'No'}</div>
        <div><strong>Is PWA:</strong> {isPWA() ? 'Yes' : 'No'}</div>
        <div><strong>Is In Mobile App:</strong> {deviceInfo.isInMobileApp ? 'Yes' : 'No'}</div>
        <div><strong>Bundle ID:</strong> {deviceInfo.bundleId || 'Not detected'}</div>
        <div><strong>App Framework:</strong> {appFramework.framework}</div>
        {appFramework.version && <div><strong>Framework Version:</strong> {appFramework.version}</div>}
        {appFramework.platform && <div><strong>Framework Platform:</strong> {appFramework.platform}</div>}
      </div>
      
      {/* iOS WebView Alert Button */}
      <div className="mt-4 pt-4 border-t border-gray-300">
        <button
          onClick={() => showIOSWebViewAlert()}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Test iOS WebView Alert
        </button>
        <p className="text-xs text-gray-500 mt-1 text-center">
          Click to test the iOS WebView alert popup
        </p>
      </div>
    </div>
  );
};

export default DeviceDetectionTest;
